import { useSettings } from "../contexts/SettingsContext";

export function AccessibilityMenu() {
  const s = useSettings();
  return (
    <div className="wmleye-a11y" data-testid="a11y-menu">
      <div className="wmleye-a11y__row">
        <label htmlFor="a11y-reduced">Reduced motion</label>
        <input
          id="a11y-reduced"
          type="checkbox"
          checked={s.reducedMotion}
          onChange={(e) => s.setOverride({ reducedMotion: e.target.checked })}
          data-testid="a11y-reduced-motion-toggle"
        />
      </div>
      <div className="wmleye-a11y__row">
        <label htmlFor="a11y-hc">High contrast</label>
        <input
          id="a11y-hc"
          type="checkbox"
          checked={s.highContrast}
          onChange={(e) => s.setOverride({ highContrast: e.target.checked })}
          data-testid="a11y-high-contrast-toggle"
        />
      </div>
      <div className="wmleye-a11y__row">
        <label htmlFor="a11y-sfx">Sound effects</label>
        <input
          id="a11y-sfx"
          type="checkbox"
          checked={s.soundEffects === "on"}
          onChange={(e) => s.setOverride({ soundEffects: e.target.checked ? "on" : "off" })}
          data-testid="a11y-sound-toggle"
        />
      </div>
      <div className="wmleye-a11y__row">
        <label htmlFor="a11y-speed">Narration speed</label>
        <select
          id="a11y-speed"
          value={s.narrationSpeed}
          onChange={(e) => s.setOverride({ narrationSpeed: e.target.value })}
          data-testid="a11y-narration-speed"
        >
          <option value="slow">Slow</option>
          <option value="normal">Normal</option>
          <option value="fast">Fast</option>
        </select>
      </div>
    </div>
  );
}
